export const CATEGORY_REQUEST = 'CATEGORY_REQUEST';
export const CATEGORY_SUCCESS = 'CATEGORY_SUCCESS';
export const CREATE_CATEGORY_REQUEST = 'CREATE_CATEGORY_REQUEST';
export const UPDATE_CATEGORY_REQUEST = 'UPDATE_CATEGORY_REQUEST';
export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST';
export const SKU_LIST_REQUEST = 'SKU_LIST_REQUEST';
export const SKU_LIST_SUCCESS = 'SKU_LIST_SUCCESS';
export const UPDATE_SKU_REQUEST = 'UPDATE_SKU_REQUEST';
export const DELETE_SKU_REQUEST = 'DELETE_SKU_REQUEST';
export const DEFAULT_SUCCESS = 'DEFAULT_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const categoryHeading = [
  {
    name: 'Product',
    label: 'SKU'
  },
  {
    name: 'Discount',
    label: '% discount'
  }
];

export const categoryTypeList = [ 'Homeowner', 'Installer' ];

export const requiredErrorText = 'This field is required.';

export const categoryErrorText = 'Catgory name is already available.';

export const addCategorySuccess = 'Category created successfully';
export const updateCategoryTypeSuccess = 'Category type updated successfully';
export const deleteCategorySuccess = 'Category deleted successfully';
export const addSKUSuccess = 'SKU added successfully';
export const updateSKUSuccess = 'SKU updated successfully';
export const deleteSKUSuccess = 'SKU deleted successfully';
